import { Link } from "react-router-dom";
import HomeEmail from "../components/Home/HomeEmail";
import logo from "../assets/images/logo.png";

const data = [
  {
    title: "QUICK LINKS",
    menus: [
      { title: "BANGLE", link: "/category/1" },
      { title: "L BRACELET", link: "/category/2" },
      { title: "L RING", link: "/category/3" },
      { title: "EARRING", link: "/category/10" },
      { title: "COUPLE BAND", link: "/category/67" },
      { title: "L PENDANT SET", link: "/category/72" },
    ],
  },
  {
    title: "USEFUL LINKS",
    menus: [
      { title: "About", link: "/AboutUs" },
      { title: "Expertise", link: "/expertise" },
      { title: "Blogs", link: "/blog" },
      { title: "Career", link: "/career" },
      { title: "Contact Us", link: "/ContactUs" },
    ],
  },
  {
    title: "TERMS & POLICY",
    menus: [
      { title: "Our Policy", link: "/our-policy" },
      { title: "Privacy Policy", link: "/privacy-policy" },
      { title: "Terms & Condition", link: "/terms-condition" },
      { title: "Shipping Policy", link: "/shipping-policy" },
      { title: "Return Policy", link: "/return-policy" },
      { title: "Cancellation Policy", link: "/cancellation-policy" },
    ],
  },
];

const Footer = () => {
  return (
    <>
      <HomeEmail />
      <footer className="footer-area">
        <div className="container">
          <div className="footer_logo_con">
            <Link to="/">
              <img src={logo} alt="kalista logo" />
            </Link>
          </div>
          {data.map((item, index) => (
            <div key={index}>
              <h4>{item.title}</h4>
              <ul className="footer_menu_con">
                {item.menus.map((menu, menuIndex) => (
                  <li key={menuIndex}>
                    {/* Check if the link is an internal link */}
                    {menu.link.startsWith("/") ? (
                      <Link to={menu.link}>{menu.title}</Link>
                    ) : (
                      <a href={menu.link}>{menu.title}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="copyright text-center">
          &copy; {new Date().getFullYear()} Kalista All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;
